import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CheckCircle2, ChevronRight } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Portfolio = () => {
  const [projects, setProjects] = useState([]);
  const [expandedIndex, setExpandedIndex] = useState(null);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axios.get(`${API}/portfolio`);
        setProjects(response.data);
      } catch (error) {
        console.error('Error fetching portfolio:', error);
      }
    };
    fetchProjects();
  }, []);

  return (
    <section id="portfolio" className="bg-white section-padding" data-testid="portfolio-section">
      <div className="container-custom">
        {/* Section Header */}
        <div className="max-w-2xl mb-12">
          <div className="overline mb-4" data-testid="portfolio-overline">
            Our Work
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight leading-tight font-heading text-[#1a1a1a] mb-4" data-testid="portfolio-heading">
            Proven Track Record
          </h2>
          <p className="text-gray-600 leading-relaxed" data-testid="portfolio-description">
            A selection of successfully completed projects for government agencies and enterprise clients.
          </p>
        </div>

        {/* Portfolio List */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-testid="portfolio-list">
          {projects.map((project, index) => (
            <div
              key={project.project_id}
              className="border-b border-gray-200 last:border-b-0"
              data-testid={`portfolio-item-${index}`}
            >
              <button
                className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors text-left"
                onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
                data-testid={`portfolio-toggle-${index}`}
              >
                <div className="flex items-center gap-6 flex-1">
                  <span className="text-xs font-medium text-gray-400 w-20" data-testid={`project-id-${index}`}>
                    {project.project_id}
                  </span>
                  <span className="font-semibold font-heading text-[#1a1a1a]" data-testid={`project-client-${index}`}>
                    {project.client_type}
                  </span>
                </div>
                <div className="flex items-center gap-4">
                  <span className="hidden sm:flex items-center gap-1 text-sm text-green-600">
                    <CheckCircle2 className="w-4 h-4" />
                    {project.status}
                  </span>
                  <span className="text-sm text-gray-400">{project.year}</span>
                  <ChevronRight className={`w-5 h-5 text-gray-400 transition-transform ${expandedIndex === index ? 'rotate-90' : ''}`} />
                </div>
              </button>
              
              {expandedIndex === index && (
                <div className="px-5 pb-5 pt-0">
                  <div className="bg-gray-50 p-4 rounded ml-20">
                    <div className="text-xs uppercase tracking-wider text-gray-500 mb-2">Specifications</div>
                    <p className="text-sm text-gray-700" data-testid={`project-spec-${index}`}>
                      {project.specification}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
